<template>
  <div class="our-verbal-idntity-content" id="identidade-verbal-nossa-identidade-verbal" data-search-anchor>
    <p class="our-verbal-idntity-title">
      {{ ourVerbalIdentityTitle }}
    </p>
    <div
      class="our-verbal-idntity-card-item"
      :style="{ backgroundImage: `url(${ourVerbalIdentityImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VerbalIdentityPageMixin from '@/mixins/verbal-identity-page-mixin'
import { VerbalIdentityPageStore } from '@/store/verbal-identity-page/verbal-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurVerbalIdentityIntroSection extends Mixins(VerbalIdentityPageMixin) {
  verbalIdentityPageStore: PageStoreContract = getModule(VerbalIdentityPageStore, this.$store)

  get ourVerbalIdentityTitle(): string {
    return this.getElementTitle(2, 0)
  }

  get ourVerbalIdentityImageSrc(): string {
    return this.getElementMedia(2, 0)
  }

  async getVerbalIdentityPage(): Promise<void> {
    await this.verbalIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.verbalIdentityPageStore.isLoading) {
      await this.getVerbalIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.our-verbal-idntity-content {
  width: 100%;
  display: grid;
  width: 1032px;
}

.our-verbal-idntity-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  text-align: left;
  margin-top: 100px;
  margin-bottom: 8px;
  width: 100%;
}

.our-verbal-idntity-card-item {
  position: relative;

  width: 1032px;
  width: 100%;
  height: 739px;

  border-radius: 20px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>